import styled from 'styled-components';

import { H2 } from './headings';
import { AnimationWrapperLi, AnimationWrapperOl } from './animationWrapper';

const Container = styled.div`
  max-width: calc(4 * (4em + 300px));
  margin: 2em auto;
  width: 100vw;
`;

// Base tile styling shared between anchor and button versions
const baseTileStyles = `
  width: 300px;
  height: 300px;
  margin: 1em;
  display: inline-block;
  border-radius: 10px;
  border: 1px solid #eee;
  box-shadow: 0 0 5px #eee;
  padding: 2em;
  padding-top: 4em;
  cursor: pointer;
  transition: 200ms linear all;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  text-align: left;
  color: inherit;

  &:hover {
    box-shadow: 0 0 10px #ddd;
    text-decoration: none;
  }

  &:focus {
    outline: 3px solid #4a90e2;
    box-shadow: 0 0 8px #4a90e2;
  }
`;

// Anchor-based tile for navigation
const Tile = styled.a<{ disabled?: boolean }>`
  ${baseTileStyles}
  text-decoration: none;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

// Button-based tile for actions like opening modals
const ButtonTile = styled.button<{ disabled?: boolean }>`
  ${baseTileStyles}
  font-family: inherit;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

const ReportTile = styled.button<{ disabled?: boolean }>`
  ${baseTileStyles}
  font-family: inherit;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: auto;
  min-width: 100px;
  height: 80px;
  padding: 0.5em;
  overflow: visible;
  position: relative;

  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

  &:after {
    content: 'CSV';
    position: absolute;
    top: 1px;
    right: 1px;
    width: 25px;
    background-color: #28a745;
    color: white;
    padding: 0.4em 0.4em;
    border-radius: 3px 9px;
    font-size: 0.5em;
    font-weight: bold;
  }
`;

const headerSizes = {
  sm: '40px',
  md: '50px',
  lg: '60px',
} as const;

const Name = styled.div<{ size?: keyof typeof headerSizes }>`
  font-size: 50px;
  line-height: 1.1em;
  font-weight: 600;

  ${(props) =>
    props.size &&
    `
    font-size: ${headerSizes[props.size]};
  `}
`;

const Header = styled(Name).attrs({ as: H2 })`
  margin-left: 18px;
  margin-bottom: 0.5em;
`;

const TopRight = styled.div`
  position: absolute;
  top: 1em;
  right: 1em;
`;

const Ol = styled(AnimationWrapperOl)`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const Ul = styled(Ol).attrs({ as: 'ul' });

const Li = styled(AnimationWrapperLi)`
  display: inline-block;
`;

export const Tiles = {
  Container,
  Tile,
  ButtonTile,
  ReportTile,
  Name,
  Header,
  TopRight,
  Ol,
  Ul,
  Li,
};
